import React from "react";
import ReactDOM from "react-dom";
import "./index.less";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "mobx-react";
import {BrowserRouter as Router} from "react-router-dom";
import {InitializedStores} from "./stores/initializeStores";
import 'moment/locale/ru'

ReactDOM.render(
    <Provider {...InitializedStores}>
        <Router /*basename={'/#'}*/>
            <App/>
        </Router>
    </Provider>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
